import { render } from "./AppGames.vue?vue&type=template&id=59cb7fba"
import script from "./AppGames.vue?vue&type=script&lang=js"
export * from "./AppGames.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__